let envFlag = process.env.VUE_APP_envFlag == null ? false :  true
var version = {
  //后台  
  'SYSTEM': {
    appId: 'b21342e0d92411e9b3a000505694becd'
  },
  // 火烧云
  'HUOSHAOYUN': {
    appId: 'b38cc221434211eabe8e00505694becd',
    healthVersion: {
      serviceId: 'x_xiamensimingshequxinxi', // 社区指引文章id
      docIdList: ['x_xiamensiming_notice_bye'], // 重要通知
      home: {
        title: '火烧云健康管理在线平台', // 首页标题
        titleEn: 'Huo Shao Yun Online Health Management System', // 首页标题英文
        copy: '火烧云健康管理在线平台', // 首页底部版权文字
        copyEn: 'Huo Shao Yun Online Health Management System', // 首页底部版权文字英文
      },
      roles: [        
        {
            role: 'hubei', // 角色代码
            name: '来自湖北或接触有症状人员', // 角色名称
            nameEn: 'Person From Hubei or contact', // 角色名称英文
            icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health9.png', //角色图标
            docId: ['x_xiamensimingzhengcejiedu', 'x_xiamensiming_user_agreement', 'x_xiamensiming_user_private'], //角色文档id
            state: 'close', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待，需配置message字段用于展示提示信息
          },
          {
            role: 'fanxia',
            name: '我是返厦到厦人员',
            nameEn: 'I am returning to xiamen', // 角色名称英文
            icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health7.png',
            docId: ['x_xiamensiming_notice_return_people', 'x_xiamensiming_user_agreement',
            'x_xiamensiming_user_private'
          ],
            state: 'close' ,
          },
          {
            role: 'doctor',
            name: '我是医护工作人员',
            nameEn: 'I am a health care worker', // 角色名称英文
            icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health8.png',
            docId: ['x_xiamensiming_notice_doctor', 'x_xiamensiming_user_agreement', 'x_xiamensiming_user_private'],
            state:'open',
          },
          {
            role: 'ixiamen',
            name: '"i厦门"入厦登记及健康管理',
            nameEn: '"i Xiamen" Arrival to Xiamen Registration', // 角色名称英文
            time:'3月6日后（含）入厦人员',
            timeEn:'Since 06.03.2020',
            icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health10.png',
            docId: ['x_xiamensiming_notice_return_people', 'x_xiamensiming_user_agreement',
              'x_xiamensiming_user_private'
            ],
            state: 'open' ,
          },
          {
            role: 'enterprise',
            name: '我是思明区企业',
            nameEn: 'I am a company in Siming District', // 角色名称英文
            icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health7.png',
            docId: ['x_xiamensiming_notice_company', 'x_xiamensiming_user_agreement', 'x_xiamensiming_user_private'],
            state: 'close' ,
          },
          {
            role: 'teacher',
            name: '我是教师人员',
            nameEn: 'I am teacher', // 角色名称英文
            icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health7.png',
            docId: ['x_xiamensiming_notice_company', 'x_xiamensiming_user_agreement', 'x_xiamensiming_user_private'],
            state: 'close' ,
          },
      ],
    },
  },
  // 上海健康
  'SHANGHAIHONGQIAO': {
    appId: 'eb21c89e49bb11eabe8e00505694becd',
    healthVersion: {
      serviceId: 'x_shanghaihongkou_cummunity', // 社区指引文章id
      home: {
        title: '上海虹口健康管理在线平台', // 首页标题
        copy: '上海虹口健康管理在线平台', // 首页底部版权文字
      },
      roles: [{
          role: 'hubei', // 角色代码
          name: '来自湖北或接触有症状人员', // 角色名称
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health9.png', //角色图标
          docId: [], //角色文档id
          state: 'close', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待
        },
        {
          role: 'fanxia',
          name: '我是返厦到厦人员',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health10.png',
          docId: ['x_shanghaihongkou_notice_return_people'],
          state: 'open',
        },
        {
          role: 'doctor',
          name: '我是医护工作人员',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health8.png',
          docId: [],
          state: 'close',
        },
        {
          role: 'enterprise',
          name: '我是上海虹口企业',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health7.png',
          docId: [],
          state: 'close',
        },
      ],
    }
  },
  // 三亚健康
  'SANYAJIANKANG': {
    appId: 'f772d95b4a8011eabe8e00505694becd',
    hsyHosName:'三亚市',
    healthVersion: {
      serviceId: 'x_sanya_cummunity', // 社区指引文章id
      home: {
        title: '三亚疫情管控平台-健康三亚', // 首页标题
        copy: '三亚疫情管控平台-健康三亚', // 首页底部版权文字
      },
      roles: [{
          role: 'hubei', // 角色代码
          name: '来自湖北或接触有症状人员', // 角色名称
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health9.png', //角色图标
          docId: [], //角色文档id
          state: 'close', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待
        },
        {
          role: 'fanxia',
          name: '我是返厦到厦人员',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health10.png',
          docId: ['x_sanya_notice_return_people'],
          state: 'open',
        },
        {
          role: 'doctor',
          name: '我是医护工作人员',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health8.png',
          docId: [],
          state: 'close',
        },
        {
          role: 'enterprise',
          name: '我是三亚企业',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health7.png',
          docId: [],
          state: 'close',
        },
      ],
    }
  },
  // 翔安康
  'XIANGANKANG': {
    appId: '0d5008834ce911eabe8e00505694becd',
    healthVersion: {
      serviceId: 'x_xiangan_cummunity', // 社区指引文章id
      home: {
        title: '翔安康管理在线平台', // 首页标题
        copy: '翔安康管理在线平台', // 首页底部版权文字
      },
      roles: [{
          role: 'hubei', // 角色代码
          name: '来自湖北或接触有症状人员', // 角色名称
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health9.png', // 角色图标
          docId: [], //角色文档id
          state: 'close', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待
          message: '敬请期待', // state为expect时，点击弹窗信息
        },
        {
          role: 'fanxia',
          name: '我是返厦到厦人员',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health10.png',
          docId: ['x_xiangan_notice_return_people'],
          state: 'open', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待
        },
        {
          role: 'doctor',
          name: '我是社区、医护人员',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health8.png',
          docId: ['x_xiangan_notice_doctor'],
          state: 'open', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待
        },
        {
          role: 'enterprise',
          name: '我是翔安区企业',
          icon: 'http://img.zx.zoenet.cn/maternalte/icon/icon-health7.png',
          docId: ['x_xiangan_notice_company'],
          state: 'open', // 三个值 open:开通入口，close：关闭入口，expect: 敬请期待
        }
      ]
    }
  },
  // 翔安码
  'XIANGANMA': {
    // 翔安码检查点
    appId: 'f97090e64fe711eabe8e00505694becd',
    checkpoint: {
      areaParameter: {
        positioning: [{
          "areaCode": "4",
          "areaName": "福建",
          "isLast": 0
        }, {
          "areaCode": "60",
          "areaName": "厦门",
          "isLast": 0
        }, {
          "areaCode": "592",
          "areaName": "翔安区",
          "isLast": 0
        }],
        queryOnlyCodeLevel: [1, 2],
        otherShow: false
      }, //创建检查点地区配置
      healthInfoFlagInterface: '/epidemicXiangAn/getHealthInfoFlag', //人员是否申报登记过接口
      userRegistrationPath: '/health_xiangan/registration', //人员申报登记地址        
    }
  },
  // 返校
  'FANXIAO': {
    appId: '65f3bd695dc811eabe8e00505694becd',
    healthVersion: {
      docIdList: ['x_hsy_fanxiao_teacher', 'x_hsy_fanxiao_student'], // 重要通知
    }
  }
}
export default version;